// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "modal";
var _12 = "modalBackdrop";
var _13 = "modalBottomed";
var _14 = "modalCentered";
var _15 = "modalChildren";
var _16 = "modalContent";
var _17 = "modalContentWithScroll";
var _18 = "modalContentWrapper";
var _19 = "modalControls";
var _1a = "modalFooter";
var _1b = "modalHeader";
var _1c = "modalHeaderWithActions";
var _1d = "modalInner";
var _1e = "modalInnerFitByContent";
var _1f = "modalInnerStretched";
var _20 = "modalInnerWide";
var _21 = "modalTitle";
var _22 = "reset-button";
var _23 = "1200px";
var _24 = "992px";
var _25 = "1366px";
var _26 = "768px";
var _27 = "1475px";
var _28 = "576px";
var _29 = "1600px";
var _2a = "320px";
var _2b = "2500px";
var _2c = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "modal", _12 as "modalBackdrop", _13 as "modalBottomed", _14 as "modalCentered", _15 as "modalChildren", _16 as "modalContent", _17 as "modalContentWithScroll", _18 as "modalContentWrapper", _19 as "modalControls", _1a as "modalFooter", _1b as "modalHeader", _1c as "modalHeaderWithActions", _1d as "modalInner", _1e as "modalInnerFitByContent", _1f as "modalInnerStretched", _20 as "modalInnerWide", _21 as "modalTitle", _22 as "reset-button", _23 as "screenlg", _24 as "screenmd", _25 as "screenml", _26 as "screensm", _27 as "screenxlg", _28 as "screenxs", _29 as "screenxxlg", _2a as "screenxxs", _2b as "screenxxxlg", _2c as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "modal": _11, "modalBackdrop": _12, "modalBottomed": _13, "modalCentered": _14, "modalChildren": _15, "modalContent": _16, "modalContentWithScroll": _17, "modalContentWrapper": _18, "modalControls": _19, "modalFooter": _1a, "modalHeader": _1b, "modalHeaderWithActions": _1c, "modalInner": _1d, "modalInnerFitByContent": _1e, "modalInnerStretched": _1f, "modalInnerWide": _20, "modalTitle": _21, "reset-button": _22, "screenlg": _23, "screenmd": _24, "screenml": _25, "screensm": _26, "screenxlg": _27, "screenxs": _28, "screenxxlg": _29, "screenxxs": _2a, "screenxxxlg": _2b, "single-page-responsive-font-size": _2c }
